import { ERRORS } from '@/constants/error';
import { STORAGE_KEY } from '@/constants/storage';
import { jsCrypto, rsaCrypto } from '@/plugins/crypto-instances';
import store from '@/store';
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';
import VueCookies from 'vue-cookies';

const isIgnoreUrl = (url) => {
    const ignoreUrlList = ['/users/login', '/users/google/callback'];
    return !ignoreUrlList.includes(url);
};

const openPopupUserBanned = (error) => {
    if (
        error?.response?.data?.messageCode.toUpperCase() ===
            ERRORS.ACCOUNT_BANNED &&
        isIgnoreUrl(error.config.url)
    ) {
        store.commit('authentication/setPopupBanned', true);
    }
};

const applyInterceptors = (axiosInstance) => {
    axiosInstance.defaults.headers.common['x-time-zone'] =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Request interceptor
    axiosInstance.interceptors.request.use((config) => {
        config.headers['x-locale'] = VueCookies.get(STORAGE_KEY.LOCALE);
        config.headers.Authorization = VueCookies.get(STORAGE_KEY.ACCESS_TOKEN);
        config.headers[STORAGE_KEY.DEVICE_TYPE] = isMobile
            ? 'mobile'
            : 'desktop';
        const websiteId = store.getters['website/currentWebsiteId'];
        if (websiteId) {
            config.headers[STORAGE_KEY.SITE] = websiteId;
            config.headers[STORAGE_KEY.CURRENCY] =
                store.getters['website/currentCurrencyId'];
        }

        // Check and encrypt secret data
        if (config.headers[STORAGE_KEY.ENCRYPTION]) {
            config.meta = config.meta || {};
            config.meta.requestTime = new Date().getTime().toString();
            const encryptBodyData = {
                data: config.data,
                requestSecret: config.meta.requestTime,
            };
            const data = rsaCrypto().encryptObject(encryptBodyData);
            config.data = { data };
        }

        return config;
    });

    // Response interceptor
    axiosInstance.interceptors.response.use(
        (response) => {
            // Check and decrypt secret data
            if (
                response.config.headers[STORAGE_KEY.ENCRYPTION] &&
                response.data.data
            ) {
                const options = {
                    secretKey: response.config.meta.requestTime,
                };
                response.data = jsCrypto(options).getDecryptedValue(
                    response.data.data
                );
            }
            return response;
        },
        (error) => {
            const code = error.response?.status || 0;
            switch (code) {
                case 401:
                    if (
                        error?.response?.data?.message.toUpperCase() ===
                        ERRORS.UNAUTHORIZED
                    ) {
                        store.dispatch('auth/logout');
                    }
                    break;
                case 403:
                    if (isIgnoreUrl(error.config.url)) {
                        store.dispatch('auth/logout');
                    }

                    if (!error.response.data.messageCode) {
                        error.response.data.messageCode = ERRORS.UNAUTHORIZED;
                    }
                    openPopupUserBanned(error);
                    break;
            }
            return Promise.reject(error);
        }
    );

    return axiosInstance;
};
export const $http = applyInterceptors(
    axios.create({
        baseURL: process.env.VUE_APP_API_URL,
    })
);
// WP service instance
export const $httpWP = applyInterceptors(
    axios.create({
        baseURL: process.env.VUE_APP_WORDPRESS_API_URL,
    })
);
